import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import configureStore from 'store/ConfigureStore';
import Routes from 'router/Router';
import Theme from 'theme/Theme';
import { setCustomerName } from 'store/home/action';
import { getCustomerFromPath } from 'services/route.service';

import './App.css';

const { store, persistor, UserParams } = configureStore();

/**
 * Seed homeState.customerName from the URL after redux-persist rehydrates and
 * before the router mounts, so any saga/middleware reading the store sees the
 * realm without depending on Layout's useEffect.
 */
const seedCustomerFromUrl = () => {
  const customer = getCustomerFromPath(window.location.pathname);
  if (customer) {
    store.dispatch(setCustomerName(customer));
  }
};

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor} onBeforeLift={seedCustomerFromUrl}>
        <React.Suspense fallback={<div>Loading...</div>}>
          <Theme>
            <Routes />
          </Theme>
        </React.Suspense>
      </PersistGate>
    </Provider>
  );
};

export default App;
